import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FiltrosSpecsheetsService {
  private storageKey = 'filtrosSpecSheets';

  get filtros() {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : {
      plant: '',
      department: '',
      customer: '',
      status: '',
      searchText: ''
    };
  }

  set filtros(value) {
    sessionStorage.setItem(this.storageKey, JSON.stringify(value));
  }

  limpiarFiltros() {
    sessionStorage.removeItem(this.storageKey);
  }

  constructor() { }
}
